// import { singleItemDefaultConfig } from '../singleitemdisplay/SingleItemDisplay'
import * as H from 'history'
import { getColumns } from './columns'

export const getControlledConfig =  (history: H.History) => ({
    header: 'Business Branch',
    columns: getColumns(history)
})